import EventsEmitter from 'events/EventsEmitter';
import { useState } from 'react';

function computeNearestScale(
	pixelWidthMin: number,
	pixelWidthMax: number,
	scale: number,
) {
	let values: any = [
		0.001,
		0.002,
		0.005,
		0.01,
		0.02,
		0.05,
		0.1,
		0.2,
		0.5,
		1.0,
		2.0,
		5.0,
		10.0,
		20.0,
		50.0,
		100.0,
		200.0,
		500.0,
		1000.0,
		2000.0,
		5000.0,
		10000.0,
		20000.0,
		50000.0,
		100000.0,
		200000.0,
		500000.0,
		1000000.0,
		2000000.0,
		5000000.0,
		10000000.0,
		20000000.0,
		50000000.0,
		100000000.0,
	];
	for (let index in values) {
		let value: number = values[index];
		if (value >= scale * pixelWidthMin) {
			return value;
		}
	}
	return 0.0;
}

function formatScaleLabel(scale: number) {
	let diff: number = scale - Math.floor(scale);
	if (diff > 0.5) {
		return scale.toFixed(2);
	} else if (diff > 0.25) {
		return scale.toFixed(1);
	} else if (diff > 0.0) {
		return scale.toFixed(2);
	} else return scale + '';
}

export default function OrthobarWidth() {
	const [orthoScale, setOrthoScale] = useState(0.0);

	EventsEmitter.on('cameraChange', (scale: number) => {
		//console.log('scale:', scale);
		setOrthoScale(scale);
	});

	let orthoDisplay = orthoScale > 0.0 ? 'block' : 'none';
	let orthoNearestScale = computeNearestScale(200, 250, orthoScale);
	let orthoBarWidth = orthoScale > 0.0 ? orthoNearestScale / orthoScale : 0.0;
	return (
		<div
			id="orthobarWidth"
			style={{
				position: 'absolute',
				right: 171,
				bottom: 70,
				width: orthoBarWidth,
				textAlign: 'right',
				backgroundColor: 'transparent',
				display: orthoDisplay,
				zIndex: 1700,
			}}
		>
			<div>
				<div style={{ width: '25%', float: 'left', fontSize: 10 }}>
					{formatScaleLabel(0.25 * orthoNearestScale)}m
				</div>
				<div style={{ width: '25%', float: 'left', fontSize: 10 }}>
					{formatScaleLabel(0.5 * orthoNearestScale)}m
				</div>
				<div style={{ width: '25%', float: 'left', fontSize: 10 }}>
					{formatScaleLabel(0.75 * orthoNearestScale)}m
				</div>
				<div style={{ width: '25%', float: 'left', fontSize: 10 }}>
					{formatScaleLabel(1.0 * orthoNearestScale)}m
				</div>
			</div>
			<div
				style={{
					width: '100%',
					height: 10,
				}}
			>
				<div
					style={{
						width: '25%',
						height: '100%',
						float: 'left',
						backgroundColor: 'black',
					}}
				></div>
				<div
					style={{
						width: '25%',
						height: '100%',
						float: 'left',
						backgroundColor: 'white',
					}}
				></div>
				<div
					style={{
						width: '25%',
						height: '100%',
						float: 'left',
						backgroundColor: 'black',
					}}
				></div>
				<div
					style={{
						width: '25%',
						height: '100%',
						float: 'left',
						backgroundColor: 'white',
					}}
				></div>
			</div>
		</div>
	);
}
